import React from "react";
import "./About.css";
import rightEllipse from "../assets/right-ellipse.png";
import logo from "../assets/logo.svg";

export const About = () => {
  return (
    <div id="About">
      <div className="about-container container">
        {<img alt="logo" className="logo" src={logo} />}
        <div className="ellipse-container">
          <img
            className="right-ellipse"
            alt="right ellipse"
            src={rightEllipse}
          />
        </div>

        <h1 className="name">Nadzeya Palitskavaya</h1>

        <div className="block block-1">
          <p>&gt; Choreographer</p>
          <p>&gt; Dancer</p>
          <p>&gt; Fitness Coach</p>
          <p>&gt; Doctor of Science</p>
        </div>

        <div className="block block-2">
          <p>20 years of experience.</p>
          <p>Participation in international ballet competitions.</p>
          <p>Over a hundred students.</p>
        </div>

        <div className="block block-3">
          <p>
            Bachelor of Fine Arts degree in Folk Dance and a Master of Arts.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
